import { Movie } from "@/types/movie";
import { v4 as uuidv4 } from 'uuid';

export const initialMovies: Movie[] = [];
